import React, { useEffect, useState } from "react";
import {Link} from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';
import {notifyError, notifySuccess } from "../../helper";
import {APP_URL, MAIL_ACCOUNT_ALL_LINK, MAIL_ACCOUNT_CREATE_LINK} from '../../constants/constants';
import Header from "../Header";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import MailBox from "./MailBox";
import NoRecord from "../NoRecord";
import DataLoader from "../DataLoader";
import EditProfilePopUp from "./EditProfilePopUp";
import client from "../../api";
import DeleteMailAccountModelWindow from "../campaigns/models/DeleteMailAccountModelWindow";
import WarmupStatus from "./WarmupStatus";


const AllMailAccounts = () => {
    const api = client();
    const [loadingData, setLoadingData] = useState(true);
    const [mailAccountRecords,setMailAccountRecords] = useState();
    const [editProfileData, setEditProfileData] = useState({});
    const [popupDisplay,setPopupDisplay] = useState(false);
    const [showAccountDeleteModelWindow, setShowAccountDeleteModelWindow] = useState(false);
    const [emailAddress,setEmailAddress] = useState('');
    const [warmupAccountId, setWarmupAccountId] = useState(null);
    
    const createGoogleLoginAccount = useGoogleLogin({
        flow: 'auth-code',
        scope: [
            "https://www.googleapis.com/auth/userinfo.profile",
			"https://www.googleapis.com/auth/userinfo.email",
			"https://www.googleapis.com/auth/gmail.send",
            "https://www.googleapis.com/auth/gmail.readonly",
            "https://www.googleapis.com/auth/gmail.insert"
        ].join(" "),
        ux_mode: "redirect",
        redirect_uri: `${APP_URL}/mail-accounts/all`
    });

    const fetchAllMailAccounts = async () => {
        try{
            const response = await api.get('/v1/mailAccount/list');
            if(response.status === 200 || response.status === 201){
                setMailAccountRecords([...response.data.data]);
                setLoadingData(false);
            }
        } catch(error){
            notifyError(error.message);
            setLoadingData(false);
        }
    }

    const createNewGoogleMailAccount = async (googleCode) => {
        try {
            if(googleCode){
                const response = await api.post('/v1/mailAccount/create/google',{
                    authCode:googleCode,
                    redirectUrl:`${APP_URL}/mail-accounts/all`
                    });
                    if(response.status === 201 || response.status === 200){
                        notifySuccess('New mail successfully account added');
                        setTimeout(()=>{
                            window.location.href = MAIL_ACCOUNT_ALL_LINK;
                        },2000);
                    }
                }              
        } catch (error) {
          console.log('error.message',error);
          if(error.status === 400){
            notifyError('Bad Request. Not able to create a mail account. Please try again');
          }
        }
    };

    const handleWarmupClick = (mailAccountId) => {
        setWarmupAccountId(mailAccountId)
    }

    const handleItemClick = (info) => {
        setEditProfileData(info);
        setPopupDisplay(true);
    }

    useEffect(()=>{
        const query = new URLSearchParams(window.location.search);
        const google_code = query.get('code');
        if(google_code){
            createNewGoogleMailAccount(google_code);
        }
    },[]);

    useEffect(()=>{
        if(mailAccountRecords === undefined) {
            fetchAllMailAccounts();
        }
    });


    return(<>
        <Header/>
        <div className="main-page">
            <Sidebar/>
            <div className="mailaccounts-pages-wrap">
               <div className="top-section">
                    <h1> Mail Accounts </h1>
                    <div className="button-group">
                        <Link to={MAIL_ACCOUNT_CREATE_LINK} className="primary-btn"><i className="bx bx-plus"></i> Add SMTP Mail Account</Link>
                        <span className="btn primary-btn" onClick={()=>{
                            createGoogleLoginAccount();
                            }}><i className="bx bx-plus"></i> Add Google Mail Account</span>
                    </div>
               </div>
               <div className="mailaccount-list-wrap">
                    {loadingData ? 
                        (<DataLoader/>):( mailAccountRecords.length > 0 ? <> 
                            {mailAccountRecords.map((row,index)=><MailBox 
                                key={index} 
                                data={row} 
                                handleEditClick={handleItemClick} 
                                handleWarmupClick={handleWarmupClick}
                                showAccountDeleteModelWindow = {showAccountDeleteModelWindow}
                                setShowAccountDeleteModelWindow = {setShowAccountDeleteModelWindow}
                                setEmailAddress = {setEmailAddress}
                                />)}
                        </>:<>
                                <NoRecord message="No Mail Account Available at this time." />
                        </>
                    )}                
               </div>
            </div>
        </div>
        <Footer/>
        {warmupAccountId? <WarmupStatus mailAccountId={warmupAccountId} handleClose={() => setWarmupAccountId(null)} />:""}
        {popupDisplay ? <EditProfilePopUp profileData={editProfileData} setPopupDisplay={setPopupDisplay} />:''}
        {showAccountDeleteModelWindow && <DeleteMailAccountModelWindow
        showAccountDeleteModelWindow = {showAccountDeleteModelWindow}
        setShowAccountDeleteModelWindow = {setShowAccountDeleteModelWindow}
        emailAddress = {emailAddress}
        />}
    </>);
}

export default AllMailAccounts;